// Banner hiện trong dialog/form khi AI emit tool call → app đang prefill.
// Đọc pending từ context, tự render hoặc null nếu không có pending.
//
// Style minimal Tailwind. App có thể override qua slot/class.

import { Sparkles, X } from "lucide-solid";
import { Show, type Component, type JSX } from "solid-js";
import { useAgentUi } from "./use-agent-ui";

export interface AiPrefilledBannerProps {
  /// Override default message. Accept string hoặc JSX (vd bold action button name).
  /// Default: "AI đề xuất chạy <toolName> — review rồi click nút action bên dưới, hoặc Cancel."
  message?: string | JSX.Element;
  /// Override default Tailwind classes (rare).
  class?: string;
}

export const AiPrefilledBanner: Component<AiPrefilledBannerProps> = (props) => {
  const ctx = useAgentUi();
  return (
    <Show when={ctx.pendingAction()}>
      {(action) => (
        <div
          class={
            props.class ??
            "px-3 py-2 rounded-md border border-blue-500/30 bg-blue-500/10 text-sm text-blue-700 dark:text-blue-300 flex items-center justify-between gap-2 mb-3"
          }
          role="status"
          aria-live="polite"
        >
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <Sparkles class="h-4 w-4 shrink-0" />
            <span class="truncate">
              {props.message ?? (
                <>
                  AI đề xuất chạy{" "}
                  <code class="font-mono text-xs bg-blue-500/15 px-1 py-0.5 rounded">
                    {action().toolName}
                  </code>{" "}
                  — review rồi click nút action (highlight) bên dưới, hoặc Cancel.
                </>
              )}
            </span>
          </div>
          <button
            type="button"
            class="inline-flex items-center gap-1 px-2 py-1 rounded text-xs hover:bg-blue-500/15 shrink-0"
            onClick={() => ctx.rejectCurrent("user clicked cancel in banner")}
            aria-label="Cancel AI request"
          >
            <X class="h-3 w-3" />
            Cancel
          </button>
        </div>
      )}
    </Show>
  );
};
